// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__TkeHe","modalFooterButton":"ModalNotes_modalFooterButton__AgC3a"};